import {LauncherComponentWithState} from './launcher-component-with-state';

export class LauncherComponentBase<TProps> extends LauncherComponentWithState<TProps, {}> {

}